module.exports = __webpack_public_path__ + "static/media/mode-14.787701cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-14.svg
// module id = 987
// module chunks = 2